import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Head from 'next/head';
import Locales from '@spa/shared/constants/locales';
import STRUCTURED_DATA from '@spa/shared/constants/structuredData';
import { translatePathFilters } from '@spa/shared/utils/url';
var SEO = function SEO(_ref) {
  var seoProps = _ref.seoProps;
  var _ref2 = seoProps || {},
    _ref2$linkedDataConte = _ref2.linkedDataContext;
  _ref2$linkedDataConte = _ref2$linkedDataConte === void 0 ? {} : _ref2$linkedDataConte;
  var organization = _ref2$linkedDataConte.organization,
    page = _ref2$linkedDataConte.page,
    metadata = _ref2$linkedDataConte.metadata,
    metaTitle = _ref2.metaTitle,
    metaDescription = _ref2.metaDescription,
    _ref2$isIndexed = _ref2.isIndexed,
    isIndexed = _ref2$isIndexed === void 0 ? true : _ref2$isIndexed,
    faqStructuredData = _ref2.faqStructuredData,
    _ref2$locale = _ref2.locale,
    locale = _ref2$locale === void 0 ? 'en' : _ref2$locale,
    asPath = _ref2.asPath,
    completeUrl = _ref2.completeUrl,
    mainPhoto = _ref2.mainPhoto;
  var url = process.env.APP_URL.slice(0, -1);
  var linkedData = STRUCTURED_DATA[organization] && STRUCTURED_DATA[organization][page] ? STRUCTURED_DATA[organization][page](_objectSpread({}, metadata)) : [];
  var getHref = function getHref(language) {
    return "".concat(url).concat(translatePathFilters(asPath, language));
  };
  return __jsx(Head, null, linkedData.map(function (schema, index) {
    return __jsx("script", {
      key: "".concat(organization, "_").concat(page, "_").concat(index),
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(schema)
      }
    });
  }), faqStructuredData && __jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(faqStructuredData)
    }
  }), __jsx("title", null, metaTitle), __jsx("meta", {
    charset: "utf-8"
  }), __jsx("meta", {
    httpEquiv: "X-UA-Compatible",
    content: "IE=edge"
  }), __jsx("meta", {
    name: "baidu-site-verification",
    content: "codeva-BnFvHwcblM"
  }), __jsx("meta", {
    name: "theme-color",
    content: "#00adef"
  }), __jsx("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1, maximum-scale=1"
  }), __jsx("meta", {
    name: "description",
    content: metaDescription
  }), __jsx("meta", {
    name: "title",
    content: metaTitle
  }), __jsx("meta", {
    property: "fb:app_id",
    content: process.env.FACEBOOK_APP_ID
  }), __jsx("meta", {
    property: "og:title",
    content: metaTitle
  }), __jsx("meta", {
    property: "og:type",
    content: "website"
  }), __jsx("meta", {
    property: "og:site_name",
    content: "Uniplaces"
  }), __jsx("meta", {
    property: "og:description",
    content: metaDescription
  }), __jsx("meta", {
    property: "og:image",
    content: mainPhoto
  }), __jsx("meta", {
    property: "og:image:type",
    content: "image/jpeg"
  }), __jsx("meta", {
    property: "og:image:url",
    content: mainPhoto
  }), __jsx("meta", {
    property: "og:image:secure_url",
    content: mainPhoto
  }), __jsx("meta", {
    property: "og:image:alt",
    content: metaDescription
  }), __jsx("meta", {
    property: "og:locale",
    content: Locales[locale === null || locale === void 0 ? void 0 : locale.toUpperCase()] || Locales.EN
  }), __jsx("meta", {
    property: "og:url",
    content: completeUrl
  }), Object.values(Locales).filter(function (value) {
    return value !== locale;
  }).map(function (content) {
    return __jsx("meta", {
      key: content,
      property: "og:locale:alternate",
      content: content
    });
  }), __jsx("meta", {
    property: "twitter:card",
    content: "summary_large_image"
  }), __jsx("meta", {
    property: "twitter:site",
    content: "@Uniplaces"
  }), __jsx("meta", {
    property: "twitter:creator",
    content: "@uniplaces"
  }), __jsx("meta", {
    property: "twitter:url",
    content: completeUrl
  }), __jsx("meta", {
    property: "twitter:title",
    content: metaTitle
  }), __jsx("meta", {
    property: "twitter:description",
    content: metaDescription
  }), __jsx("meta", {
    property: "twitter:image",
    content: mainPhoto
  }), __jsx("meta", {
    name: "alexaVerifyID",
    content: "-rCIO1OdzObYj0ckOXGvAr9Jiyg"
  }), isIndexed === false && __jsx(React.Fragment, null, __jsx("meta", {
    name: "robots",
    content: "noindex,follow"
  }), __jsx("meta", {
    name: "googlebot",
    content: "noindex,follow"
  })), __jsx("link", {
    rel: "canonical",
    href: getHref(locale)
  }), __jsx("link", {
    rel: "alternate",
    hrefLang: "x-default",
    href: getHref('en')
  }), Object.keys(Locales).map(function (key) {
    return __jsx("link", {
      key: key,
      rel: "alternate",
      hrefLang: key.toLowerCase(),
      href: getHref(key.toLowerCase())
    });
  }), __jsx("link", {
    rel: "shortcut icon",
    href: "".concat(process.env.CDN_URL, "/images/icon-48x48.png")
  }));
};
export default SEO;